<!--
 * @Author: Haoxiwei 1078734933@qq.com
 * @Date: 2023-09-08 09:58:45
 * @LastEditors: Haoxiwei 1078734933@qq.com
 * @LastEditTime: 2023-09-11 09:31:26
 * @FilePath: /wemeet-iam/Users/hvv/weMeetSpace/WeMeet_admin_project/wemeet-admin/src/views/dragger/template/tpl-publish.vue
 * @Description: 
 * Copyright (c) 2023 by WeMeet, All Rights Reserved. 
-->
<!--
* @description:
* @fileName tpl-banner.vue
* @author hvv
* @date 2022/01/11 13:13:31
!-->
<template>
  <div class="layout">
    <div class="background">
      <div class="title" :style="{ color: res.list[0].color }">
        {{ res.list[0].title }}
      </div>

      <div style="content">
        <div v-for="(item, index) in 2" :key="index" class="contentItem">
          <div class="name">动态 xxxxxxxxxxxx</div>
          <div class="time">09/02</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import { defineAsyncComponent, defineComponent, getCurrentInstance, onMounted, reactive, toRefs, watch } from 'vue'
  export default defineComponent({
    name: 'TplTitle',
    props: {
      res: Object,
    },
    setup(props, { emit }) {
      const { proxy } = getCurrentInstance

      const state = reactive({
        nowItem: {},
        fit: 'fill',
      })
      onMounted(() => {})
      watch(
        () => props.res,
        (newVal, oldVal) => {},
        { deep: true }
      )

      return {
        ...toRefs(state),
      }
    },
  })
</script>
<style lang="scss" scoped>
  @import './tpl.scss';
  .background {
    position: absolute;
    z-index: 2;
    width: 100%;

    height: 142px;
    background: url('https://wemeet-1302608036.cos.ap-shanghai.myqcloud.com/MEHZ/images/title.png') no-repeat;
    background-size: cover;
  }
  .layout {
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    min-height: 142px;
    text-align: center;

    background: #ffffff;
  }
  .title {
    font-size: 15px;
    font-weight: bold;
    line-height: 42px;
  }
  .content {
    .contentItem {
      width: 335px;
      height: 43px;
      line-height: 43px;
      text-align: left;
      padding: 0 10px;
      display: flex;
      justify-content: space-between;
      .name {
        font-size: 13px;
        font-weight: 400;
        color: #262626;
      }
      .time {
        font-size: 13px;
        font-weight: 400;
        color: #999999;
      }
    }
  }
</style>
